import React, {Fragment, Component} from 'react';
import Overlay from 'Components/Overlay';
import Input from 'Components/Input';
import Select from 'react-select';
import { getUser } from 'Utils/storage';

export default class CreateGroupCard extends Component {
    constructor(props) {
        super(props);
        this.state={
            groupName:"",
            selectedOption: null,
            slecteddOptionList:[],
            isEnableConfirm:false,
        }
    }
    onChange=(e)=> {
        const { providerType } = this.props;
        const { selectedOption, isEnableConfirm } = this.state;
        this.setState({
            [e.target.name]: e.target.value,
            selectedOption: providerType === 24 ? [{
                label: getUser().companyName,
                value: getUser().companyId
            }] : selectedOption,
            isEnableConfirm: providerType === 24 ? true : isEnableConfirm
        })
    }
    handleBranchSelection = (selectedOption) => {
        let { isEnableConfirm } = this.state;
        isEnableConfirm = (selectedOption.length>0);
    
        this.setState({ selectedOption, isEnableConfirm });
        
    }
    createGroup = ()=> {
        let { selectedOption, slecteddOptionList } = this.state;
        if(selectedOption && selectedOption != null){
            selectedOption.forEach((item) => {
                slecteddOptionList.push(item.value);
            });
        }
        this.props.createGroup(this.state.groupName,  slecteddOptionList);
    }
    render() {
        const { transporters, onCancel, branchesList, providerType } = this.props;
        return(
            <Fragment>
                <Overlay>
                    <div className="bg-white box-shadow ph-20 pv-20 br-5">
                        <Input value={this.state.groupName} placeholder="Group name" onChange={this.onChange} name="groupName"/>
                       {providerType !== 24 && <Select
                            isMulti
                            options={branchesList}
                            className="mt-20 mb-20"
                            placeholder="Select Branch"
                            value={this.state.selectedOption}
                            onChange={this.handleBranchSelection}
                        />}
                        <div className="col-1 ht-60 flex flex-middle flex-center bg-white">
                            <button className="ht-40 br-20 theme-color border-theme fs-16 fBold pl-30 pr-30 mr-30" onClick={onCancel}>Cancel</button>
                           { this.state.isEnableConfirm && <button className="ht-40 br-20 white-color bg-theme fs-16 fBold pl-30 pr-30" onClick={this.createGroup}>Confirm</button>}
                        </div>
                    </div>    
                </Overlay> 
            </Fragment>
        );
    }
}
